import { graphql } from 'react-relay';

export const tradeVerifyFirmReminderQuery = graphql`
    query tradeVerifyFirmReminderQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                verifiedTradeStatus
            }
        }
    }
`;
